import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { AiTaskQueue } from '../../helpers/schema';

export const schema = z.object({
  queueId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type QueueItemWithDetails = Selectable<AiTaskQueue> & {
  taskTitle: string;
  personaName: string;
  personaIcon: string;
  triggeredByName: string;
  resultContent?: string;
};

export type OutputType = {
  item: QueueItemWithDetails | null;
};

export const getAiQueueStatus = async (
  params: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(params);
  const searchParams = new URLSearchParams();
  searchParams.set('queueId', validatedInput.queueId);
  const result = await fetch(`/_api/ai-queue/status?${searchParams.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
